import React from "react";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // You could log to a service here
    console.error("ErrorBoundary caught:", error, errorInfo);
  }

  handleReload = () => {
    this.setState({ hasError: false, error: null });
    if (this.props.onReset) this.props.onReset();
  };

  handleHome = () => {
    window.location.href = "/";
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-slate-50 p-4">
          <div className="bg-white rounded-2xl shadow-lg p-6 max-w-md w-full text-center">
            <div className="text-6xl mb-3">💥</div>
            <h1 className="text-2xl font-bold text-slate-800 mb-2">
              เกิดข้อผิดพลาด
            </h1>
            <p className="text-slate-500 mb-4">
              หน้านี้มีปัญหา — กรุณาลองใหม่ หรือกลับหน้าหลัก
            </p>
            {this.state.error && (
              <pre className="text-left bg-red-50 border border-red-200 rounded p-2 text-xs text-red-700 overflow-auto max-h-32 mb-4">
                {String(this.state.error?.message || this.state.error)}
              </pre>
            )}
            <div className="flex gap-2 justify-center">
              <button
                onClick={this.handleReload}
                className="px-4 py-2 hover: rounded-lg font-semibold btn-apple-primary"
              >
                🔄 ลองอีกครั้ง
              </button>
              <button
                onClick={this.handleHome}
                className="px-4 py-2 bg-slate-200 hover:bg-slate-300 text-slate-700 rounded-lg font-semibold"
              >
                🏠 กลับหน้าหลัก
              </button>
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
